import React from 'react';
import "./ShadowBoxComponent.css";

function ShadowBoxComponent(props) {

    return (
        <div
            className={`${'content'} ${props.disabled ? 'disabled' : ''} ${props.className ? props.className : ''}`}
            style={props.style}
        >
            {props.children}
        </div>
    );
}

export default ShadowBoxComponent;
